import { Controller } from '@hotwired/stimulus'
import KelvinDataLayer from '../lib/kelvin_data_layer'

export default class extends Controller {
  static values = {
    event: Object,
    payload: { type: Object, default: {} },
    pushOnConnect: { type: Boolean, default: false }
  }

  connect () {
    if (!window.kelvinDataLayer) {
      window.kelvinDataLayer = new KelvinDataLayer()
    }
    if (this.pushOnConnectValue) {
      this.push()
    }
  }

  push () {
    if (this.hasEventValue) {
      window.kelvinDataLayer.push(this.eventValue, this.payloadValue)
    }
  }
}
